export const LOCAL_SERVICE_CONFIG = {
  taklaggare: {
    label: "Takläggare", shortLabel: "Takläggning", globalPath: "/taklaggare/", image: "hero",
    promise: "En samlad partner för kontroll, planering, material, plåt och utförande.",
    lead: "Vi hjälper dig att avgöra om taket behöver underhåll, riktad reparation eller ett komplett byte.",
    needs: ["Takbyte och omläggning", "Renovering av befintligt tak", "Underlag, läkt och takmaterial", "Plåtdetaljer och avvattning"]
  },
  takbesiktning: {
    label: "Takbesiktning", shortLabel: "Besiktning", globalPath: "/takbesiktning/", image: "inspection",
    promise: "Ett tydligt beslutsunderlag innan du investerar, planerar solceller eller prioriterar underhåll.",
    lead: "Vi går igenom takets synliga skick och hjälper dig förstå vad som är akut, vad som kan planeras och vad som bör följas upp.",
    needs: ["Status inför takprojekt", "Underlag inför solceller", "Kontroll efter väderpåverkan", "Plan för underhåll"]
  },
  takservice: {
    label: "Takservice", shortLabel: "Service", globalPath: "/takservice/", image: "rooferWork",
    promise: "Rätt åtgärd i rätt tid kan förlänga takets liv och minska risken för följdskador.",
    lead: "Takservice passar när du har ett avgränsat problem eller vill ta hand om taket innan en mindre brist blir större.",
    needs: ["Läckage och lokala skador", "Pannor, infästningar och tätningar", "Rännor och avvattning", "Förebyggande underhåll"]
  },
  takmalning: {
    label: "Takmålning", shortLabel: "Målning", globalPath: "/takmalning/", image: "roofPainting",
    promise: "Förarbete, rätt färgsystem och ett noggrant utförande ger ett jämnt och hållbart resultat.",
    lead: "Vi bedömer om taket är lämpligt för målning och vilka förberedelser som krävs för materialet.",
    needs: ["Tvätt och förbehandling", "Kontroll av underlaget", "Målning och rostskydd av plåttak", "Planerat ytskydd"]
  },
  platslageri: {
    label: "Plåtslageri", shortLabel: "Plåt", globalPath: "/platslageri/", image: "villaMetal",
    promise: "TISAB:s egen plåtverkstad knyter ihop takets funktion, detaljer och uttryck.",
    lead: "Vi hjälper med måttanpassade plåtdetaljer och plåtarbeten som ska fungera tillsammans med resten av taket.",
    needs: ["Beslag och anslutningar", "Rännor och stuprör", "Skorstens- och fönsterdetaljer", "Plåttak och kompletteringar"]
  },
  serviceavtal: {
    label: "Serviceavtal för tak", shortLabel: "Serviceavtal", globalPath: "/serviceavtal/", image: "brfAerial",
    promise: "Planerade kontroller ger bättre framförhållning för styrelse, förvaltare och fastighetsägare.",
    lead: "Ett serviceavtal skapar en återkommande rytm för kontroll, dokumentation och prioriterade åtgärder.",
    needs: ["Återkommande kontroll", "Dokumenterade observationer", "Prioritering av åtgärder", "Budget- och underhållsunderlag"]
  },
  takskottning: {
    label: "Takskottning", shortLabel: "Snö & is", globalPath: "/snoskottning/", image: "snowRemoval",
    promise: "Säker planering för snö och is när belastning, rasrisk eller framkomlighet behöver hanteras.",
    lead: "Vi hjälper fastighetsägare att bedöma behov och planera en säker insats med hänsyn till tak och omgivning.",
    needs: ["Snölast på tak", "Risk för snöras och is", "Säkra arbetsvägar", "Samordning runt fastigheten"]
  }
};

export function getLocalPageMeta(serviceSlug, location) {
  const service = LOCAL_SERVICE_CONFIG[serviceSlug];
  if (!service || !location) return null;
  const path = `/${serviceSlug}/${location.slug}/`;
  const preposition = location.slug === "lidingo" ? "på" : "i";
  const place = `${preposition} ${location.name}`;
  const searchCopy = {
    taklaggare: {
      benefit: "takbyte & renovering",
      description: `Takläggare ${place} för takbyte och renovering. TISAB hjälper med material, underarbete och plåtdetaljer. Beskriv ditt tak och begär kostnadsfri offert.`
    },
    takbesiktning: {
      benefit: "kontroll av taket",
      description: `Takbesiktning ${place} inför takbyte, underhåll eller solceller. TISAB går igenom takets skick och hjälper dig prioritera åtgärder. Boka en genomgång.`
    },
    takservice: {
      benefit: "reparation & underhåll",
      description: `Takservice ${place} för läckage, skadade pannor och avvattning. TISAB hjälper med felsökning och underhåll. Beskriv problemet och få en bedömning.`
    },
    takmalning: {
      benefit: "underhåll av plåttak",
      description: `Takmålning ${place}: bedömning av plåttaket, rengöring, rostbehandling och målning. TISAB hjälper dig välja rätt åtgärd. Begär offert för ditt tak.`
    },
    platslageri: {
      benefit: "egen plåtverkstad",
      description: `Plåtslageri ${place} med måttanpassade beslag, rännor och takdetaljer. TISAB har egen plåtverkstad. Berätta om ditt plåtarbete och begär offert.`
    },
    serviceavtal: {
      benefit: "BRF & fastighet",
      description: `Serviceavtal för tak ${place}. Planera kontroller, dokumentation och underhåll med TISAB. För BRF och fastighetsägare. Diskutera ett upplägg för ert tak.`
    },
    takskottning: {
      benefit: "snö & istappar",
      description: `Takskottning ${place} för BRF och fastighetsägare. TISAB hjälper med snö, is och planering runt fastigheten. Kontakta oss om behov och vinteravtal.`
    }
  }[serviceSlug];
  if (serviceSlug === "taklaggare" && location.slug === "danderyd") {
    return {
      path,
      title: "Takläggare i Danderyd – takbyte & plåt | TISAB",
      h1: "Takläggare i Danderyd",
      metaDescription: "Takläggare i Danderyd för villa, radhus och BRF. TISAB hjälper med takbyte, besiktning och plåt. Skicka adress och bilder så bedömer vi taket."
    };
  }
  return {
    path,
    title: `${service.label} ${place} – ${searchCopy.benefit} | TISAB`,
    h1: `${service.label} ${place}`,
    metaDescription: searchCopy.description
  };
}